@if (consumer) {
<div class="contact-page">
    <div class="header-section">
        <div class="header">
            @if (this.appFacadeService.getIsAdmin() | async) {
            <h1 class="theme-heading">{{ 'ContactListFor' | translate }} {{ consumer.Name }}</h1>
            } @else {
            <h1 class="theme-heading">{{ 'UserListFor' | translate }} {{ consumer.Name }}</h1>
            }
            <por-base-button [featureName]="'contact-close'" (click)="onCloseButtonClick()" icon="close"></por-base-button>
        </div>
    </div>
    <div class="content-wrapper" porAddFeature featureName="aggridheader">
        <div class="filters">
            <por-filters [initFilters]="initFilters" [multiFilters]="filterValues" [enableSearchBox]="false" [enableDateSearchBox]="false" (filterOutput)="filter($any($event))"></por-filters>
        </div>
        <ag-grid-angular
            style="width: 100%; height: 100%"
            class="ag-theme-alpine ag-grid"
            [defaultColDef]="defaultColDef"
            [columnDefs]="columnDefs"
            [rowData]="filteredContacts()"
            [gridOptions]="gridOptions"
            [rowHeight]="65"
            [headerHeight]="35"
            (gridReady)="onGridReady($event)"
            [context]="context" />
    </div>
</div>
}
